var _path, _path2, _path3, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerifiedShieldGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356,
    height: 425,
    viewBox: "0 0 356 425",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.609163 83C0.609163 83 64.1091 75.5 99.6092 56C135.109 36.5 176.609 0 176.609 0C176.609 0 215.609 37.5 252.109 56C288.609 74.5 354.609 83 354.609 83C354.609 83 358.5 157 348.5 206C338.5 255 328.391 296 289.5 335.5C250.609 375 176.609 425 176.609 425C176.609 425 91.1092 369 64.1092 335.5C37.1091 302 21.6092 251.5 9.10916 206C-3.39084 160.5 0.609163 83 0.609163 83Z",
    fill: "#9F9F9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4916 107.986C35.4916 107.986 86.74 101.933 115.391 86.1953C144.041 70.4576 177.534 41 177.534 41C177.534 41 209.01 71.2647 238.467 86.1953C267.925 101.126 321.191 107.986 321.191 107.986C321.191 107.986 324.331 167.708 316.261 207.254C308.19 246.8 300.031 279.889 268.644 311.768C237.257 343.647 177.534 384 177.534 384C177.534 384 108.531 338.805 86.74 311.768C64.9493 284.732 52.4399 243.975 42.3516 207.254C32.2634 170.533 35.4916 107.986 35.4916 107.986Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4271 121.198C53.4271 121.198 97.952 115.939 122.844 102.266C147.736 88.5929 176.835 63 176.835 63C176.835 63 204.181 89.2941 229.774 102.266C255.367 115.238 301.644 121.198 301.644 121.198C301.644 121.198 304.373 173.085 297.361 207.442C290.349 241.8 283.261 270.548 255.991 298.245C228.722 325.941 176.835 361 176.835 361C176.835 361 116.884 321.734 97.952 298.245C79.0201 274.755 68.1519 239.346 59.3872 207.442C50.6224 175.539 53.4271 121.198 53.4271 121.198Z",
    fill: "#9F9F9F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 213.336,
    width: 27.8827,
    height: 76.9723,
    transform: "rotate(-46.8311 114 213.336)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 237.518,
    y: 156,
    width: 27.8827,
    height: 126.363,
    transform: "rotate(43.2103 237.518 156)",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedShieldGray);
export default __webpack_public_path__ + "static/media/verified_shield_gray.664a6e13ee383a422e0589cb963d3a01.svg";
export { ForwardRef as ReactComponent };